import { Box, BoxProps, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import theme from "../../../theme";
import { capitalize } from "lodash";

const InfoBlock = ({
  title,
  children,
  action,
  childrenContainerSx,
  dataTestId,
}: {
  title: string;
  children: ReactNode;
  action?: ReactNode;
  childrenContainerSx?: BoxProps["sx"];
  dataTestId?: string;
}) => {
  return (
    <Box data-testid={dataTestId}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6" fontSize={16} fontWeight="600" color={"black"}>
          {capitalize(title)}
        </Typography>
        {action ? (
          <Stack direction="row" spacing={2} ml={1}>
            {action}
          </Stack>
        ) : null}
      </Box>
      <Box
        sx={{
          backgroundColor: theme.palette.primaryBackground.main,
          borderRadius: 2,
          padding: 1,
          mt: 1,
          ...childrenContainerSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default InfoBlock;
